import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface CreateSubDealerPayload {
  username: string;
  password: string;
  balance?: number;
  dealerId: number;
  image?: string;
}

export async function createDealer(
  payload: CreateSubDealerPayload
): Promise<NewUser> {
  const res = await api.client.post("/sub-dealers-new", payload);
  return res.data;
}
